import "./App.css";
import FaqList from "./FaqList";
import { Box, Typography } from "@mui/material";
import { useState, useEffect } from 'react';

function App() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  
  // Add a state to track if the counter should be shown
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    const weddingDate = new Date('2026-08-28T13:30:00');
    
    const timer = setInterval(() => {
      const now = new Date();
      const difference = weddingDate.getTime() - now.getTime();
      
      if (difference <= 0) {
        // Wedding day has arrived
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setShowCounter(false);
      } else {
        // Calculate time left
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        setTimeLeft({ days, hours, minutes, seconds });
        
        // Show counter only if at least one value is greater than zero
        setShowCounter(days > 0 || hours > 0 || minutes > 0 || seconds > 0);
      }
    }, 1000);
    
    // Cleanup the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <Box
        sx={{
          height: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden"
        }}
      >
        <video
          src="/bajor-kama.mp4"
          autoPlay
          loop
          muted
          playsInline
          style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }}
        />
      </Box>

      {/* Main Content */}
      <Box
        my={5}
        sx={{
          p: { xs: 0, lg: 4 },
          textAlign: "center",
        }}
      >
        <Typography variant="h3" fontFamily={"Charm, serif"}>
          Kamila & Mateusz
        </Typography>
        <Typography variant="h4" fontFamily={"Charm, cursive"}>
          28.08.2026
        </Typography>
        
        {/* Only show the countdown if showCounter is true */}
        {showCounter && (
          <Typography variant="h5" fontFamily={"Charm, cursive"} mt={2}>
            {timeLeft.days} dni, {timeLeft.hours} godzin, {timeLeft.minutes} minut, {timeLeft.seconds} sekund
          </Typography>
        )}
      </Box>
      <Box>
        <FaqList />
      </Box>
      <Box sx={{ pb: 8 }} />
    </div>
  );
}

export default App;